import { IconButton } from '@dixa/lib-shared-habla';
import classnames from 'classnames';

import styles from './sidekickLauncher.module.scss';

type SidekickLauncherProps = {
  hasUnread: boolean;
  autoFocus: boolean;
  onClick: () => void;
};

export const SidekickLauncher = ({
  hasUnread,
  autoFocus,
  onClick,
}: SidekickLauncherProps): JSX.Element => {
  return (
    <span className={classnames(styles.wrapper, 'print-hidden')}>
      <IconButton
        icon="mim-sidekick"
        variant="primary"
        onClick={onClick}
        autoFocus={autoFocus}
        iconSize={24}
        aria-label={hasUnread ? 'Open Sidekick, new reply' : 'Open Sidekick'}
        className={styles.launcher}
        size="large"
      />
      {hasUnread && <span className={styles.dot} aria-hidden="true" />}
    </span>
  );
};
